import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown";
import { AnimatePresence } from "framer-motion";
import { Menu, Pen, Send, Trash2, Unplug } from "lucide-react";
import { useState } from "react";
import { PartialApp } from "../types/app.type";
import AppAPI from "./AppAPI/AppAPI";
import AppEdit from "./AppEdit";
import DeleteApp from "./DeleteApp/DeleteApp";
import { ShareApp } from "./ShareApp/ShareApp";

interface Props {
  app: PartialApp;
}

function AppActions({ app }: Props) {
  const [openEdit, setOpenEdit] = useState(false);
  const [openShare, setOpenShare] = useState(false);
  const [openAPI, setOpenAPI] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const isOrganizationApp = app.origin === "organization";

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon">
            <Menu size={14} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {isOrganizationApp && (
            <>
              <DropdownMenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenEdit(true);
                }}
                className="gap-2"
              >
                <Pen size={14} /> Edit app
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenShare(true);
                }}
                className="gap-2"
              >
                <Send size={14} /> Share app
              </DropdownMenuItem>
            </>
          )}
          {app.defaultDeployment?.apiURL && (
            <DropdownMenuItem
              onClick={(e) => {
                e.stopPropagation();
                setOpenAPI(true);
              }}
              className="gap-2"
            >
              <Unplug size={14} /> API settings
            </DropdownMenuItem>
          )}
          {isOrganizationApp && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDelete(true);
                }}
                className="gap-2"
                destructive
              >
                <Trash2 size={14} /> Delete app
              </DropdownMenuItem>
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <span onClick={(e) => e.stopPropagation()} role="button" tabIndex={0}>
        <AnimatePresence>
          {openEdit && isOrganizationApp && (
            <AppEdit app={app} setOpen={setOpenEdit} />
          )}
          {openShare && isOrganizationApp && (
            <ShareApp app={app} setOpen={setOpenShare} />
          )}
          {openAPI && app.defaultDeployment?.apiURL && (
            <AppAPI app={app} setOpen={setOpenAPI} />
          )}
          {openDelete && isOrganizationApp && (
            <DeleteApp
              appName={app.displayName}
              appSlug={app.slug}
              setOpen={setOpenDelete}
            />
          )}
        </AnimatePresence>
      </span>
    </>
  );
}

export default AppActions;
